import { env } from '@/config';

export const STORAGE_KEYS = {
  ACCESS_TOKEN: env.auth.accessTokenStorageKey,
  REFRESH_TOKEN: env.auth.refreshTokenStorageKey,
  REMEMBER_ME: 'justtable.rememberMe',
  THEME_MODE: 'justtable.themeMode',
  LOCALE: 'justtable.locale',
  SIDEBAR_COLLAPSED: 'justtable.sidebarCollapsed',
} as const;

export type StorageKey = (typeof STORAGE_KEYS)[keyof typeof STORAGE_KEYS];
